import React, { useState,useEffect } from 'react';
import moment from 'moment';
import {
  Button,
  Modal,
  Col,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  FormFeedback,
  Label,
  Input
} from "reactstrap";
import httpClient from "../../http-client/client";
import DatePicker from "react-datepicker";
const Popup = props => {
  
    const [date, setdate] = useState(new Date(props.data[0].create_datetime));
    const [status, setstatus] = useState(props.data[0].fcm_message_status?"Sent":"Failed");
    const [Title, setTitle] = useState(props.data[0].fcm_message_title);
    const [body, setbody] = useState(props.data[0].fcm_message_body);
    const [success, setsuccess] = useState(props.data[0].success_count);
    const [Failed, setFailed] = useState(props.data[0].failed_count);
    const [AgentStatus, setAgentStatus] = useState(props.data[0].failed_count);
    const [ee, setee] = useState(()=>{
      if(props.data[0].agent_status_id==1){
        setAgentStatus("Registered - رجسٹرڈ")
      }else if(props.data[0].agent_status_id==2){
        setAgentStatus("Active - فعال")
      }
      else if(props.data[0].agent_status_id==3){
        setAgentStatus("عدم ادائیگی کی وجہ سے معطل")
      }
      else if(props.data[0].agent_status_id==4){
        setAgentStatus("Blocked - معطل")
      }else{
        setAgentStatus("All")
      }
    });
    // useEffect(async() => {
    //   let { data } =  await httpClient.get(`/refer/sendFcm/${props.Id}`);
    // },[]);
  return (
    <div className="popup-box">
      <div className="box">
        <span className="close-icon" onClick={props.handleClose}>x</span>
        <div>
        <Form className='row'>


<div className="row col-md-12">



      
         </div>
         <div className="row col-md-12">
        

        
         </div>
         <div className="row col-md-12">
         <FormGroup className="col-sm-12">
           <Label for="partyName">Date</Label>
           <DatePicker
   style={{ dipslay: "block" }}
   dateFormat="dd/MM/yyyy"
   selected={date}
   disabled={true}
//    onChange={this.handleSalePurchaseDate}
 />
         
         </FormGroup>
         </div>
    <div className="row col-md-12">
    <FormGroup className="col-sm-12 col-md-6">
           <Label for="partyName">Status </Label>
           <Input
             type="text"
             value={status}
             name="start_rate"
             id="start_rate"
             placeholder="Status"
            disabled={true}
            //  onChange={(e)=>{this.setState({start_rate:e.target.value})}}
           />
          
         </FormGroup>
         <FormGroup className="col-sm-12 col-md-6">
           <Label for="partyName">Agent Status</Label>
           <Input
             type="text"
             value={AgentStatus}
             name="end_rate"
             id="end_rate"
             placeholder="Agent Status"
             disabled={true}
            //  onChange={(e)=>{this.setState({end_rate:e.target.value})}}
           />
         
         </FormGroup>
    </div>
    <div className="row col-md-12">
    <FormGroup className="col-sm-12 col-md-6">
           <Label for="partyName"> Sent</Label>
           <Input
             type="text"
             value={success}
             name="start_rate"
             id="start_rate"
             placeholder="Sent Count"
             disabled={true}
            //  onChange={(e)=>{this.setState({start_rate:e.target.value})}}
           />
          
         </FormGroup>
         <FormGroup className="col-sm-12 col-md-6">
           <Label for="partyName">Failed</Label>
           <Input
             type="text"
             value={Failed}
             name="end_rate"
             id="end_rate"
             placeholder="Failed Count"
             disabled={true}
            //  onChange={(e)=>{this.setState({end_rate:e.target.value})}}
           />
         
         </FormGroup>
    </div>
    <div className="row col-md-12">
    <FormGroup className="col-sm-12 col-md-6">
           <Label for="partyName"> Title</Label>
           <Input
             type="text"
             value={Title}
             name="start_rate"
             id="start_rate"
             placeholder="Title"
             disabled={true}
            //  onChange={(e)=>{this.setState({start_rate:e.target.value})}}
           />
          
         </FormGroup>
         </div>
         <div className="row col-md-12">
         <FormGroup className="col-sm-12 col-md-6">
           <Label for="partyName">Body</Label>
           <Col sm={12}>
           <Input
             type="textarea"
             value={body}
             name="end_rate"
             id="end_rate"
             placeholder="Body"
             disabled={true}
            //  onChange={(e)=>{this.setState({end_rate:e.target.value})}}
           />
        </Col>
         </FormGroup>
    </div>


         <div className='col-sm-12 col-md-12 text-left'>
        
           <Button
             className='small '
             color='danger'
             style={{marginLeft:"20px"}}
             onClick={props.handleClose}
           >
            منسوخ کریں
           </Button>
         </div>
       </Form>
        </div>
      </div>
    </div>
  );
};
 
export default Popup;